export * from './app-aside.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-aside/index.ts